export default __webpack_public_path__ + "static/launchdarkly-mobile-77e50dec5b98e9e93c89c1e92e999cd3.jpg";